import React from 'react'

import styled from '@emotion/styled'
import { mq, text } from '../../../_style';
import ContentWidth from '../contentWidth';
import Image from '../../atoms/image';

const Container = styled.section`
  padding: 90px 0;
  ${mq.sp} {
    padding: 60px 0;
  }
`
const TextContainer = styled.div`
  margin: 0 auto;
  ${mq.pc} {
    display: flex;
    justify-content: space-between;
    align-items: center;
    max-width: 860px;
  }
`
const Img = styled.div`
  width: 108px;
  ${mq.pc} {
    flex: 1 0 auto;
    margin-right: 70px;
  }
  ${mq.sp} {
    margin: 0 auto 30px;
  }
`
const Text = styled.div`
  ${text('16px', (36/18))}
`

export default class AboutBox extends React.Component {
  render() {
    return(
      <Container>
        <ContentWidth>
          <TextContainer>
            <Img><Image filename={'about/logo-intro.png'} alt="モンダミン"></Image></Img>
            <Text>{this.props.children}</Text>
          </TextContainer>
        </ContentWidth>
      </Container>
    )
  }
}
